import { VALIDATION_VARIANTS } from '@gef-ui/material-theme-utils';
import { inputLabelClasses } from '@mui/material/InputLabel';
export default function InputLabel(theme) {
    return {
        MuiInputLabel: {
            styleOverrides: {
                root: {
                    '&.Mui-disabled, &.Mui-focused:not(.MuiFormLabel-colorError)': {
                        color: theme.palette.text.secondary
                    },
                    variants: VALIDATION_VARIANTS.map((variant)=>({
                            props: {
                                validation: variant
                            },
                            style: {
                                color: theme.palette[variant].main,
                                [`&.${inputLabelClasses.disabled}`]: {
                                    color: theme.palette[variant].main
                                }
                            }
                        }))
                }
            }
        }
    };
}
